import { render, staticRenderFns } from "./category-select.vue?vue&type=template&id=4e265a00&scoped=true&"
import script from "./category-select.vue?vue&type=script&lang=js&"
export * from "./category-select.vue?vue&type=script&lang=js&"
import style0 from "./category-select.vue?vue&type=style&index=0&id=4e265a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e265a00",
  null
  
)

export default component.exports